// src/pages/homepage/data/sportsActivities.js
import sport1 from '../IMG_9703-1.webp';
import sport2 from '../IMG_9699-1.webp';
import sport3 from '../IMG_9710-1.webp';
import sport4 from '../IMG_9704-1.webp';
import sport5 from '../IMG_9702-1.webp';
import sport6 from '../IMG_9700-1-1.webp';

export const sportsActivities = [
  {
    image: sport2,
    title: "Тренажёрный зал",
    count: "67 залов",
    link: "/gyms"
  },
  {
    image: sport1,
    title: "Водные виды спорта", 
    count: "17 залов",
    link: "/water-sports"
  },
  {
    image: sport6,
    title: "Стретчинг и пилатес",
    count: "44 зала", 
    link: "/stretching"
  },
  {
    image: sport5,
    title: "Йога",
    count: "17 залов",
    link: "/yoga"
  },
  {
    image: sport4,
    title: "Интенсивные занятия",
    count: "12 залов",
    link: "/intensive"
  },
  {
    image: sport3,
    title: "Единоборства", 
    count: "4 зала",
    link: "/martial-arts"
  }
];
